<div
  [ngClass]="{'h-100 align-content-baseline': page.includes('pending') || page === 'rejected' || page === 'validated', 'isMobile':isMobile}"
  class="position-relative content-container py-4 row m-0">

  <div
    [ngClass]="{'pt-4': isMobile, 'pb-lg-0' : page.includes('pending') || page === 'rejected' || page === 'validated'}"
    class="col-sm-12 col-lg-7 col-xl-7 d-flex flex-column pb-0">

    <app-component-booking-info *ngIf="booking && room && isMobile" [booking]="booking" [page]="page"
                                [room]="room"></app-component-booking-info>
    <app-process-navbar (newPage)="changePage($event)" *ngIf="!loading && showNavbar"
                        [links]="links"></app-process-navbar>

    <!------------------------------ COMPONENTS ------------------------------>
    <div *ngIf="room && (page === 'paiement' || page === 'informations' || page === 'post-reservation' || page == 'pending' || !isRoomAvailable)"
      class="position-relative flex-grow-1 pb-0">
      <app-component-paiement *ngIf="page === 'paiement' && room && room['disponibility']" [booking]="booking"
        [price]="price" [promoCode]="promoCode" [room]="room"></app-component-paiement>
      <app-component-informations (newPage)="changePage($event)" *ngIf="page === 'informations'"
        [room]="room"></app-component-informations>
      <app-component-pending *ngIf="page == 'pending' && booking" [booking]="booking"></app-component-pending>

      <div *ngIf="!isRoomAvailable">
        <h1
          class="font-trueno-bold font-28 txt-darkGray mb-3">{{ 'PROCESSES.ACCOMMODATION.ACCOMMODATION_UNAVAILABLE.TITLE' | translate }}</h1>
        <p [innerHTML]="'PROCESSES.ACCOMMODATION.ACCOMMODATION_UNAVAILABLE.TEXT1' | translate"
           class="mediumGray font-16 mb-4"></p>
        <button (click)="goToList()" class="btn btn-primary">{{ 'HEADER.DASHBOARD' | translate }}</button>
      </div>
    </div>

    <!--  PRE CANCEL, CANCEL, REFUSED, VALIDATED  -->
    <div *ngIf="text.title && page !== 'informations' && page != 'pending'" [ngClass]="{'mb-4': isMobile}"
         class="position-relative d-flex flex-column justify-content-start justify-content-md-center h-100">
      <h5 class="title_4">
        {{ text.title | translate}}
        <svg class="ms-1 pb-2" width="24" height="24" viewBox="0 0 32 32" fill="#FF4747" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.8822 0C1.40054 0 0.918833 0.183942 0.551301 0.551472C-0.183767 1.28653 -0.183767 2.47818 0.551301 3.21324L13.3382 16L0.551301 28.7868C-0.183766 29.5218 -0.183767 30.7135 0.551301 31.4485C0.919304 31.8165 1.40031 32 1.8822 32C2.36408 32 2.84509 31.8165 3.21309 31.4485L16 18.6618L28.7869 31.4485C29.1549 31.8165 29.6359 32 30.1178 32C30.5997 32 31.0807 31.8165 31.4487 31.4485C32.1838 30.7135 32.1838 29.5218 31.4487 28.7868L18.6618 16L31.4487 3.21324C32.1838 2.47818 32.1838 1.28653 31.4487 0.551472C30.7136 -0.183588 29.522 -0.183588 28.7869 0.551472L16 13.3382L3.21309 0.551472C2.84556 0.183941 2.36385 0 1.8822 0Z" fill="#FF4747"/>
          </svg>
      </h5>
      <h6 *ngIf="text.subtitle" class="subtitle_1 mt-3"> {{ text.subtitle | translate  }} </h6>
      <h6 *ngIf="text.subtitle2" class="subtitle_1 mt-3"> {{ text.subtitle2 | translate  }} </h6>      <p *ngIf="text.p1" [ngClass]="{'mb-3' : !text.p1}" class="mt-2 mediumGray"> {{ text.p1 | translate }} </p>
      <h6 *ngIf="text.subtitle3" class="subtitle_1 mt-3"> {{ text.subtitle3 | translate  }} </h6>
      <p *ngIf="text.p2" [ngClass]="{'mb-3' : !text.p3}" class="mt-3 mediumGray"> {{ text.p2 | translate }} </p>
      <p *ngIf="text.p3" class="mt-3 mediumGray mb-3"> {{ text.p3 | translate }} </p>

      <div class="d-flex flex-row gap-24 mt-lg-4 align-items-center bg-white pt-3 pt-lg-0 btn-div">

        <button (click)="cancelBooking(text.btn1 === 'dashboard' ? 'dashboard' : (wantCancelBooking ? 'cancel' : 'precancel'))" [ngClass]="[isMobile ? 'py-4 font-21' : 'py-3', getCancelStyle()]"
                class="btn br-4 bg-white border-2">
          <span [ngClass]="isMobile ? 'font-24' : 'font-20'"
                class="material-icons va-sub">{{ (text.btn1 === 'cancel' ? 'close' : 'dashboard')}}</span>
          {{ text.btn1_text | translate }}
        </button>

        <button (click)="goTo()" [ngClass]="isMobile ? 'py-4 font-21' : 'py-3'"
                class="btn btn-primary br-4 fw-bold flex-grow-1">
          <span [ngClass]="isMobile ? 'font-24' : 'font-20'" class="material-icons va-sub">{{ text.btn2 }}</span>
          {{ text.btn2_text | translate }}
        </button>
      </div>
    </div>

  </div>

  <!------------------------------ RIGHT FIXED DIV ------------------------------>
  <div class="position-sticky col-sm-12 col-lg-5 col-xl-5 h-fit-content">
    <app-component-booking-info *ngIf="booking && room && !isMobile" [booking]="booking" [page]="page"
                                [room]="room"></app-component-booking-info>
  </div>

</div>



<ng-template #endBookingModal let-modal>
  <div class="p-4">
    <div class="d-flex flex-row justify-content-between">
      <h3>{{ 'PROCESSES.ACCOMMODATION.CLOSE_BOOKING_TITLE' | translate }}</h3>
      <button type="button" class="border-0 bg-white" aria-label="Close" (click)="modal.close()">
        <span class="fa fa-close"></span>
      </button>
    </div>
    <div class="mt-4">
      <p>{{ 'PROCESSES.ACCOMMODATION.CLOSE_BOOKING_TEXT' | translate }}</p>
      <div class="d-flex justify-content-between">
        <button class="btn border-0 lightGray align-items-center" type="button" (click)="modal.dismiss()">
          {{ "COMMON.CANCEL" | translate }}
        </button>
        <button type="button" class="btn btn-primary mt-3" (click)="closeBooking()">{{ 'PROCESSES.ACCOMMODATION.CLOSE_BOOKING' | translate }}</button>
      </div>

    </div>

  </div>
</ng-template>
